import { render } from "./CourseInsights.vue?vue&type=template&id=79e882ba&ts=true"
import script from "./CourseInsights.vue?vue&type=script&lang=ts"
export * from "./CourseInsights.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__